module.exports = __webpack_public_path__ + "static/media/testimonialone.ddc21a88.png";